module.exports = (__webpack_public_path__ || '') + "static/images/bubble-1fa64d6eda350861ed477d8628865e2e.png";